var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { Row, Col, AccordionSet, MultiColumnList, KeyValue, TextLink, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { FieldRow } from "../../components/FieldRow";
import { AccordionSection } from "../../components/AccordionSection";
import { ExpandCollapseToggle } from "../../components/ExpandCollapseToggle";
import { translateCollectionType } from "../../utils/collectionTypeUtils";
import { formatCollectionMedium, formatCollectionStatus, } from "../../utils/collectionDisplayUtils";
import { usePermissions } from "../../hooks/usePermissions";
import styles from "./CollectionDetail.module.css";
var CollectionDetail = function (_a) {
    var collection = _a.collection;
    var intl = useIntl();
    var history = useHistory();
    var canViewPublisherDetail = usePermissions().canViewPublisherDetail;
    var _b = useState({
        general: true,
        otherNames: true,
    }), accordionStatus = _b[0], setAccordionStatus = _b[1];
    var _c = useState(true), expandAll = _c[0], setExpandAll = _c[1];
    var toggleAccordion = function (section) {
        setAccordionStatus(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[section] = !prevState[section], _a)));
        });
    };
    var toggleExpandCollapseAll = function () {
        if (expandAll) {
            setAccordionStatus({
                general: false,
                otherNames: false,
            });
        }
        else {
            setAccordionStatus({
                general: true,
                otherNames: true,
            });
        }
        setExpandAll(!expandAll);
    };
    var renderPublisherLink = function (publisher) {
        if (!(publisher === null || publisher === void 0 ? void 0 : publisher.sourceId) || !(publisher === null || publisher === void 0 ? void 0 : publisher.name) || !canViewPublisherDetail)
            return (publisher === null || publisher === void 0 ? void 0 : publisher.name) || "";
        return (React.createElement(TextLink, { onClick: function () {
                return history.push("/bragency/publishers/detail?sourceId=".concat(publisher.sourceId));
            } }, publisher.name));
    };
    var renderPublisherNames = function (publisherNames) {
        if (!publisherNames || publisherNames.length === 0)
            return "";
        return (React.createElement(React.Fragment, null, publisherNames.map(function (name) { return (React.createElement("div", { key: name }, name)); })));
    };
    var renderIssnLink = function (issn) {
        if (!issn)
            return "";
        return (React.createElement(TextLink, { to: "https://portal.issn.org/resource/ISSN/".concat(issn), target: "_blank", rel: "noopener noreferrer" }, issn));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.collections.detail.pane.title" })),
        React.createElement(ExpandCollapseToggle, { expanded: expandAll, onToggle: toggleExpandCollapseAll }),
        React.createElement(AccordionSet, null,
            React.createElement(AccordionSection, { id: "general-info", labelId: "ui-br-agency.collections.accordions.label.general", open: accordionStatus.general, onToggle: function () { return toggleAccordion("general"); } },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.collections.table.columns.type", value: translateCollectionType(collection.type || "", intl.formatMessage) }))),
                React.createElement(Row, { className: styles.fieldRow },
                    React.createElement(Col, { xs: 12 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-br-agency.collections.general.publisher.selection.label" }), value: renderPublisherLink(collection.publisher) }))),
                React.createElement(Row, { className: styles.fieldRow },
                    React.createElement(Col, { xs: 12 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-br-agency.collections.table.columns.issn" }), value: renderIssnLink(collection.issn || "") }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.collections.table.columns.mainName", value: collection.mainName }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.collections.general.qualifier.field.label", value: collection.qualifier || "" }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.collections.general.status.select.label", value: formatCollectionStatus(collection, intl.formatMessage) }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.collections.general.medium.select.label", value: formatCollectionMedium(collection.medium, intl.formatMessage) }))),
                React.createElement(Row, { className: styles.fieldRow },
                    React.createElement(Col, { xs: 12 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-br-agency.collections.detail.publishersFromTitles.label" }), value: renderPublisherNames(collection.publisherNames) }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(TextLink, { onClick: function () {
                                return history.push("/bragency/titles?collection=".concat(collection.id));
                            } },
                            React.createElement(FormattedMessage, { id: "ui-br-agency.collections.detail.showTitles" }))))),
            collection.otherLanguageNames &&
                collection.otherLanguageNames.length > 0 && (React.createElement(AccordionSection, { id: "other-names", labelId: "ui-br-agency.collections.accordions.label.otherNames", open: accordionStatus.otherNames, onToggle: function () { return toggleAccordion("otherNames"); } },
                React.createElement(MultiColumnList, { contentData: collection.otherLanguageNames, visibleColumns: ["name"], columnMapping: {
                        id: "",
                        name: intl.formatMessage({
                            id: "ui-br-agency.collections.otherNames.table.columns.name",
                        }),
                    }, formatter: {
                        id: function (item) { return item.id || ""; },
                        name: function (item) { return item.name || ""; },
                    }, interactive: false, isEmptyMessage: intl.formatMessage({
                        id: "ui-br-agency.collections.otherNames.table.empty",
                    }) }))))));
};
export default CollectionDetail;
